import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { FinancialDocumentPdfTemplateType } from '@mews-commander/data-access';
import { FormSelectField, lt } from '@mews/framework';
import { createHandler } from '@mews/std';
import { DropdownItem } from '@optimus-web/core';

const getPrimaryText = createHandler<FinancialDocumentPdfTemplateType, React.ReactNode>(
    {
        [FinancialDocumentPdfTemplateType.Detailed]: lt('DetailedInvoice'),
        [FinancialDocumentPdfTemplateType.Consumption]: lt('OverviewByDate'),
        [FinancialDocumentPdfTemplateType.Reservation]: lt('OverviewByReservation'),
        [FinancialDocumentPdfTemplateType.OrderItem]: lt('GeneralOverview'),
        [FinancialDocumentPdfTemplateType.Guest]: lt('BillFormatOverviewByGuest'),
    },
    lt('DetailedInvoice')
);

const getSecondaryText = createHandler<FinancialDocumentPdfTemplateType, React.ReactNode>(
    {
        [FinancialDocumentPdfTemplateType.Detailed]: lt('DetailedInvoiceDescription'),
        [FinancialDocumentPdfTemplateType.Consumption]: lt('OverviewByDateDescription'),
        [FinancialDocumentPdfTemplateType.Reservation]: lt('OverviewByReservationDescription'),
        [FinancialDocumentPdfTemplateType.OrderItem]: lt('GeneralOverviewDescription'),
        [FinancialDocumentPdfTemplateType.Guest]: lt('BillFormatOverviewByGuestDescription'),
    },
    lt('DetailedInvoiceDescription')
);

const getTemplateOptions = (allowedTemplateTypes: Array<FinancialDocumentPdfTemplateType>) =>
    pipe(
        allowedTemplateTypes,
        array.map((template) => (
            <DropdownItem
                key={template}
                value={template}
                label={getPrimaryText(template)}
                description={getSecondaryText(template)}
            />
        ))
    );

interface FinancialDocumentTemplateSelectFieldProps {
    name: string;
    allowedTemplateTypes: FinancialDocumentPdfTemplateType[];
}

export const FinancialDocumentTemplateSelectField = ({
    name,
    allowedTemplateTypes,
}: FinancialDocumentTemplateSelectFieldProps) => {
    return (
        <FormSelectField name={name} helper={lt('BillFormatHelper')} label={lt('BillFormat')} defaultValue="Detailed">
            {getTemplateOptions(allowedTemplateTypes)}
        </FormSelectField>
    );
};
